import { CalculatorPage } from 'pageModules/CalculatorPage';

export default CalculatorPage;
